// 公共样式
export const commonStyle = {
  rotate: 0,
  opacity: 1,
}

export const commonAttr = {
  animations: [],
  events: {},
  groupStyle: {}, // 当一个组件成为 Group 的子组件时使用
  isLock: false, // 是否锁定组件
  collapseName: 'style', // 编辑组件时记录当前使用的是哪个折叠面板，再次回来时恢复上次打开的折叠面板，优化用户体验
  linkage: {
    duration: 0, // 过渡持续时间
    data: [
      // 组件联动
      {
        id: '', // 联动的组件 id
        label: '', // 联动的组件名称
        event: '', // 监听事件
        style: [{ key: '', value: '' }], // 监听的事件触发时，需要改变的属性
      },
    ],
  },
}

// 编辑器左侧组件列表
const list = [
  {
    component: 'VText',
    label: '文字',
    propValue: '双击编辑文字',
    icon: 'wenben',
    request: {
      method: 'GET',
      data: [],
      url: '',
      series: false, // 是否定时发送请求
      time: 1000, // 定时更新时间
      paramType: '', // string object array
      requestCount: 0, // 请求次数限制，0 为无限
    },
    style: {
      width: 200,
      height: 28,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: 'center',
      color: '#000',
      padding: 4,
    },
  },
  {
    component: 'RectShape',
    label: '矩形',
    propValue: '&nbsp;',
    icon: 'juxing',
    style: {
      width: 200,
      height: 200,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: 'center',
      color: '#000',
      borderColor: '#000',
      borderWidth: 1,
      backgroundColor: '',
      borderStyle: 'solid',
      borderRadius: '',
      verticalAlign: 'middle',
    },
  },
  {
    component: 'LineShape',
    label: '直线',
    propValue: '',
    icon: 'zhixian',
    style: {
      width: 200,
      height: 2,
      backgroundColor: '#000',
    },
  },
  {
    component: 'VTable',
    label: '表格',
    icon: 'biaoge',
    propValue: {
      data: [
        ['表头1', '表头2', '表头3'],
        ['内容1', '内容2', '内容3'],
      ],
      stripe: true,
      thBold: true,
    },
    request: {
      method: 'GET',
      data: [],
      url: '',
      series: false,
      time: 1000,
      paramType: '', // string object array
      requestCount: 0, // 请求次数限制，0 为无限
    },
    style: {
      width: 300,
      height: 200,
      fontSize: 14,
      fontWeight: 400,
      textAlign: 'center',
      color: '#000',
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
  {
    component: 'VInsertImg',
    label: '插入图片',
    icon: 'el-icon-picture-outline',
    propValue: {
      img: require('@/assets/title.jpg'),
      onclickUrl: '',
    },
    style: {
      width: 375,
      height: 100,
      borderRadius: '',
      top: 0,
      left: 0,
    },
  },
  {
    component: 'VSwiper',
    label: '轮播图',
    propValue: {
      img1: { img: require('@/assets/1.png'), onclickUrl: '' },
      img2: { img: require('@/assets/2.webp'), onclickUrl: '' },
      img3: { img: '', onclickUrl: '' },
      img4: { img: '', onclickUrl: '' },
      img5: { img: '', onclickUrl: '' },
      img6: { img: '', onclickUrl: '' },
    },
    icon: 'tupian',
    style: {
      width: 375,
      height: 120,
      borderWidth: 1,
      borderColor: '#000',
      borderRadius: '',
      left: 0,
      top: 0,
    },
  },
  {
    component: 'VButton',
    label: '查询按钮',
    propValue: '防伪查询',
    icon: 'button',
    style: {
      width: 100,
      height: 34,
      borderWidth: 1,
      borderColor: '',
      borderRadius: 15,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: 'center',
      color: '#fff',
      backgroundColor: '#0000FF',
    },
  },
  {
    component: 'VInputCode',
    label: '输入防伪码',
    propValue: '请输入防伪码',
    icon: 'el-icon-edit-outline',
    style: {
      width: 180,
      height: 34,
      borderWidth: 1,
      borderColor: '',
      borderRadius: 10,
      fontSize: 10,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: 'center',
      color: '#000',
      backgroundColor: '#FFF',
    },
  },

  {
    component: 'VResult',
    label: '查询结果',
    propValue: {
      show: true,
      code: {
        name: '防伪码',
        switch: true,
      },
      queryNum: {
        name: '查询次数',
        switch: false,
      },
      firstTime: {
        name: '首次查询',
        switch: false,
      },
    },
    icon: 'el-icon-tickets',
    style: {
      width: 250,
      height: 200,
      borderWidth: 1,
      borderColor: '',
      borderRadius: 15,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '',
      letterSpacing: 0,
      textAlign: 'center',
      color: '#000',
      backgroundColor: '',
    },
  },
]

for (let i = 0, len = list.length; i < len; i++) {
  const item = list[i]
  item.style = { ...commonStyle, ...item.style }
  list[i] = { ...commonAttr, ...item }
}

export default list
